import { render, staticRenderFns } from "./TextEditorSetting.vue?vue&type=template&id=6e4a0748&scoped=true&lang=pug"
import script from "./TextEditorSetting.vue?vue&type=script&lang=ts"
export * from "./TextEditorSetting.vue?vue&type=script&lang=ts"
import style0 from "./TextEditorSetting.vue?vue&type=style&index=0&id=6e4a0748&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4a0748",
  null
  
)

export default component.exports